// Mock store profile service with localStorage persistence
import imageStore from './imageStore';

const STORAGE_KEY = 'geppro_store_profile';

function loadProfile() {
  try {
    const json = localStorage.getItem(STORAGE_KEY);
    return json ? JSON.parse(json) : null;
  } catch {
    return null;
  }
}

function saveProfile(profile) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
  } catch {}
}

const seedProfile = {
  id: 1,
  name: 'Mercadinho do Rancho',
  category: 'Alimentos e Bebidas',
  email: 'mercadinho.rancho@example.com',
  code: 'MERCRANCHO15',
  about: '🏪 Mercadinho do Rancho — Seu cantinho de sabor e praticidade! Aqui você encontra uma seleção de comidas, bebidas e produtos essenciais para o dia a dia, sempre com qualidade e aquele toque acolhedor do interior. Ideal para quem busca variedade, preço justo e atendimento de confiança.',
  // logo: blob key stored in IndexedDB via imageStore
  logoKey: null,
  contact: {
    supportEmail: 'empresaexemplo@suporte.com',
    phone: '+55 11 12345-6789',
    address: {
      cep: '12345-076',
      country: 'Brasil',
      state: 'SP',
      city: 'São Paulo',
      district: 'Novo Imperador',
      street: 'Rua Gladiador Pires',
      number: '14B',
      complement: 'Esquina'
    }
  },
  // media items store blob keys; UI resolves to object URLs at runtime
  media: []
};

const storeProfileService = {
  async fetchProfile() {
    return new Promise(resolve => {
      setTimeout(() => {
        const profile = loadProfile() || seedProfile;
        // Seed localStorage if empty
        if (!loadProfile()) saveProfile(profile);
        resolve(profile);
      }, 200);
    });
  },

  async updateProfile(payload) {
    return new Promise(resolve => {
      setTimeout(() => {
        const current = loadProfile() || seedProfile;
        const next = { ...current, ...payload, updatedAt: new Date().toISOString() };
        saveProfile(next);
        resolve(next);
      }, 200);
    });
  },

  async addMedia(file) {
    // persist file blob in IndexedDB and save key in profile
    const key = await imageStore.saveImage(file);
    const newItem = { id: Date.now(), key };
    const current = loadProfile() || seedProfile;
    const next = { ...current, media: [...(current.media || []), newItem] };
    saveProfile(next);
    return newItem;
  },

  async removeMedia(id) {
    const current = loadProfile() || seedProfile;
    const target = (current.media || []).find(m => m.id === id);
    const next = { ...current, media: (current.media || []).filter(m => m.id !== id) };
    saveProfile(next);
    if (target?.key) {
      try { await imageStore.deleteImage(target.key); } catch {}
    }
    return true;
  },

  async updateLogo(file) {
    const current = loadProfile() || seedProfile;
    // delete previous logo if present
    if (current.logoKey) {
      try { await imageStore.deleteImage(current.logoKey); } catch {}
    }
    const key = await imageStore.saveImage(file);
    const next = { ...current, logoKey: key };
    saveProfile(next);
    return next;
  },

  async getLogoUrl() {
    const current = loadProfile() || seedProfile;
    if (!current.logoKey) return null;
    return await imageStore.getImageUrl(current.logoKey);
  },

  async resolveMediaUrls() {
    const current = loadProfile() || seedProfile;
    const items = await Promise.all((current.media || []).map(async m => ({
      id: m.id,
      key: m.key,
      url: m.key ? await imageStore.getImageUrl(m.key) : null
    })));
    return items;
  }
};

export default storeProfileService;
